// @flow
import { isEmpty } from 'lodash';
import { type TRootStore } from '../../types';

export const getVenues = (state: TRootStore): Array<Object> =>
	state.venues.ordered_ids.map(item => state.venues.by_id[item]);

export const getVenuesById = (state: TRootStore): Object => state.venues.by_id;

export const hasVenues = (state: TRootStore): boolean =>
	isEmpty(state.venues.ordered_ids) === false;


// WEBPACK FOOTER //
// ./src/modules/selectors/venues/index.js